import { Component } from '@angular/core';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
  selector: 'app-career-header-banner',
  templateUrl: './career-header-banner.component.html',
  styleUrl: './career-header-banner.component.scss',
  standalone: false
})
export class CareerHeaderBannerComponent {
  Images = IMAGES;
}
